import { useAppBar } from "components";
import { useEffect } from "react";
import { Breadcrumb } from "../../../models";
import { getToolsBreadcrumb } from "../main/ToolsPage";

export function getChildAgeAnalysisBreadcrumb(): Breadcrumb {
  return {
    title: "Child Age Analysis",
    path: "/tools/child-age-analysis",
  };
}

export function ChildAgeAnalysisAppBarSetup() {
  const appBar = useAppBar();

  useEffect(() => {
    appBar.setDefaults();
    appBar.setTitle("Child Age Analysis");
    appBar.setBackUrl("/tools");
    appBar.setBreadcrumbs([getToolsBreadcrumb(), getChildAgeAnalysisBreadcrumb()]);
  }, []);

  return null;
}
